import BaseService from './baseService'; 



export class PrincipalsService extends BaseService {
    constructor(){
        const baseUrl = "/principals";
        super(baseUrl);
    }  
} 